// extracted by mini-css-extract-plugin
export default {"logos":"Accreditations_logos__WpXnu","logo":"Accreditations_logo__zros4","image":"Accreditations_image__sWL3W","middle":"Accreditations_middle__bduA+"};